import axios from 'axios'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions'

export default function editarPontoEmbarque(id, comando) {
  const url = `${URL}/ponto-embarque/${id}`
  return () => axios.put(url, comando, SLOW_REQUEST_CONFIG)
}
